import translate from "../locales";
import csmartLogo from "../assets/images/csmart.png";

export function Footer({ bottomLeftImg, bottomRightImg, onPrivacyClick }) {
  return (
    <footer className="footer">
      <div className="footer__images">
        <img src={bottomLeftImg} alt="" className="footer__corner" />
        <div className="footer__center">
          <img src={csmartLogo} alt="" className="footer__logo" />
          <div className="footer__links">
            <p className="footer__text">
              {translate("footer.made_by")}&nbsp;
              <a
                href="https://treecompany.be"
                target="_blank"
                className="footer__link"
                rel="noreferrer"
              >
                Tree company
              </a>
            </p>
            <button
              type="button"
              className="footer__link"
              onClick={onPrivacyClick}
            >
              {translate("footer.privacy")}
            </button>
          </div>
        </div>
        <img src={bottomRightImg} alt="" className="footer__corner" />
      </div>
    </footer>
  );
}
